var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarningIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.228,
    height: 41.071,
    viewBox: "0 0 103.228 91.071",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ffe600;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Warning",
    transform: "translate(-548.886 -589.929)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pol\\xEDgono_1",
    "data-name": "Pol\\xEDgono 1",
    className: "cls-1",
    d: "M57.5,13.929a1.937,1.937,0,0,0-1.729,1L12.168,90A2,2,0,0,0,13.9,93h87.2a2,2,0,0,0,1.729-3l-43.6-75.071a1.937,1.937,0,0,0-1.729-1m0-6a7.926,7.926,0,0,1,6.918,3.982l43.6,75.071A8,8,0,0,1,101.1,99H13.9A8,8,0,0,1,6.98,86.982l43.6-75.071A7.926,7.926,0,0,1,57.5,7.929Z",
    transform: "translate(543 582)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Linha_61",
    "data-name": "Linha 61",
    className: "cls-1",
    d: "M0,29.742a3,3,0,0,1-3-3V0A3,3,0,0,1,0-3,3,3,0,0,1,3,0V26.742A3,3,0,0,1,0,29.742Z",
    transform: "translate(600 621.619)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_71",
    "data-name": "Elipse 71",
    className: "cls-1",
    cx: 4.65,
    cy: 4.651,
    rx: 4.65,
    ry: 4.651,
    transform: "translate(595.35 656.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Elipse_71_-_Contorno",
    "data-name": "Elipse 71 - Contorno",
    className: "cls-1",
    d: "M4.65,1A3.651,3.651,0,1,0,8.3,4.651,3.655,3.655,0,0,0,4.65,1m0-1A4.651,4.651,0,1,1,0,4.651,4.651,4.651,0,0,1,4.65,0Z",
    transform: "translate(595.35 656.5)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/WarningIcon.a888fb6ea304585f851fd497265b45e5.svg";
export { ForwardRef as ReactComponent };